const SlickSlider = ($, type) => {
	const experienceBreakpoints = [
		{
			breakpoint: 1600,
			settings: {
				slidesToShow: 3.5,
			},
		},
		{
			breakpoint: 1400,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 1000,
			settings: {
				slidesToShow: 2.5,
			},
		},
		{
			breakpoint: 700,
			settings: {
				slidesToShow: 2,
				arrows: false,
			},
		},
		{
			breakpoint: 550,
			settings: {
				slidesToShow: 1.7,
				arrows: false,
			},
		},
		{
			breakpoint: 450,
			settings: {
				slidesToShow: 1.3,
				arrows: false,
			},
		},
		{
			breakpoint: 355,
			settings: {
				slidesToShow: 1.1,
				arrows: false,
			},
		},
	];

	const testimoniesBreakpoints = [
		{
			breakpoint: 1600,
			settings: {
				slidesToShow: 3.1,
			},
		},
		{
			breakpoint: 1300,
			settings: {
				slidesToShow: 2.3,
			},
		},
		{
			breakpoint: 700,
			settings: {
				slidesToShow: 1.5,
				arrows: false,
			},
		},
		{
			breakpoint: 550,
			settings: {
				slidesToShow: 1.2,
				arrows: false,
			},
		},
	];
	$(document).ready(function () {
		$("#js-slick-slider").slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 5,
			slidesToScroll: 1,
			prevArrow: '<div class="slick-prev slick-arrow"></div>',
			nextArrow: '<div class="slick-next slick-arrow"></div>',
			responsive:
				type === "experience-slider"
					? experienceBreakpoints
					: testimoniesBreakpoints,
		});
	});
};

export default SlickSlider;
